/**
 * !!! IMPORTANT !!!
 *    Istnieje kopia mechanizmu z tego pliku w folderze otp -> otp-representative-page -> src -> pages -> AffiliatePage.
 *    Dodając nowego partnera w tym pliku, należy dodać go również w bliźniaczym pliku w projekcie otp-representative-page !!!
 * !!! IMPORTANT !!!
*/



import React, { useEffect } from 'react';
import { DateTime } from 'luxon'
import { isEmpty } from 'lodash'

import { apphistory } from '../../../store'
import { useGetParamsObjectFromQuery } from '../../../common/useGetParamsObjectFromQuery'
import Cookies from 'universal-cookie/es6'
import { AppLinks } from '../../../environment/app-links'
import { STORAGEKEYS } from '../../../common/keys'
import settingsService from '../../../service/settings-service'
import { Environment } from '../../../environment/app-settings'
import { affiliateAlternativeOffert, affiliateAlternativeOffertsNames, affiliatePartnersNames, affiliatePartnersQueryParams, enablePredefinedPeriodsLogicForAffiliatePartner, PREDEFINED_PERIODS_EXCLUDED_PARTNERS } from '../affiliatePartnersData'
import LoanInitService, { loanInitService } from '../../../service/LoanInitService'
import { IAffiliateDataModel, IPredefinedAffiliateDataModel } from '../../../models/form/IFormSubmitionModel'
import { useDispatch } from 'react-redux'
import { AFFILIATE_PRESET_OFFERT, SET_LOAN_LIMITS } from '../../../store/actions/loan-calculator-actions'
import { IAffiliatePartnersConfigModel } from '../AffiliatePageProps'
import { SET_CURRENT_SELECTED_PREDEFINED_PERIOD, SET_IS_PREDEFINED_PERIODS_AVAILABLE } from '../../../store/actions/application-actions'


const useAffiliatePageLogic = () => {
   const dispatch = useDispatch()
   const cookie = new Cookies();

   const affiliateQueryParamsObjectFromLink = useGetParamsObjectFromQuery();
   let redirectToPageLink = AppLinks.basicInfoForm

   /**
       * Funkcja określa czy dany link pochodzi od danego partnera afiliacyjnego po nazwach parametrów
       *  
       * Zwracająca informację o tym czy wszystkie nazwy parametrów z linku afiliacyjnego
       * zgadzają się z nazwami parametrów podanych w tablicy partnerów afiliacyjnych.
       * 
       * @param partnerParams Tablica ze spodziewanymi nazwami parametrów dla konkretnego partnera afiliacyjengo  
       * @returns { Boolean } Informacja czy link pochodzi od danego partnera
   */
   const hasLinkParamsContainsPartnerParams = (partnerParams: string[]) => {
      return partnerParams.every(partnerParam => Object.keys(affiliateQueryParamsObjectFromLink).includes(partnerParam))
   }

   /**
    * Funkcja sprawdzajaca czy w linku afiliacyjnym przekazany został parametr, po którym wybieramy alternatywną ofertę z alternatywnymi zakresami i parametrami pożyczki
    */
   const setAffiliateAlternativeOffert = (): IPredefinedAffiliateDataModel | {} => {
      const affiliateAlternativeOffertNameFromLink = affiliateQueryParamsObjectFromLink?.affiliate_alternative_offert as affiliateAlternativeOffertsNames

      if(affiliateAlternativeOffertNameFromLink !== undefined && Object.values(affiliateAlternativeOffertsNames).includes(affiliateAlternativeOffertNameFromLink)){
         const newOffetFromAffiliation = affiliateAlternativeOffert[affiliateAlternativeOffertNameFromLink]
         
         dispatch({
            type: SET_LOAN_LIMITS,
            payload: newOffetFromAffiliation.loanParams
         })

         dispatch({
            type: AFFILIATE_PRESET_OFFERT,
            payload: {
               requestedAmount: newOffetFromAffiliation.defaultLoanAmount,
               instalments: newOffetFromAffiliation.defaultInstalments,
            }
         })

         return { alternativeOffertNameFromFront: affiliateAlternativeOffertNameFromLink }
      }

      return {}
   }

   /**
       * Funkcja obsługująca utworzenie ciasteczka z danymi afiliacyjnymi
       * 
       * @param affiliateData Dane do zapiania w ciasteczku
       * @returns 
   */
   const setAffiliateCookie = async(affiliateData: IAffiliateDataModel) => {
   
         // Jeśli istnieje już jakieś ciasteczko z danymi afiliacyjnymi NIE NADPISUJEMY GO (mechanizm biznesowy)
         if(!isEmpty(cookie.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE))){ 
            return
         }
   
         const affiliateCookieExpiresTimeInHours = await getAffiliateCookieExpiresTimeInHours(affiliateData.partnerId)
   
         cookie.set(
            STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE, 
            affiliateData, 
            { expires: DateTime.local().plus({ hours: affiliateCookieExpiresTimeInHours }).toJSDate() }
         )
      }

    /**
       * Funkcja obsługująca utworzenie rekordu statystycznego w bazie danych SQL z danego wejścia
       * na link afiliacyjny. Dane zapisywane w tabeli `OtpAffiliateStatistics`
       * 
       * !! IMPORTANT !! - FUNKCJA MUSI ZOSTAĆ URUCHOMIONA DLA KAŻDEGO PARTNERA AFILIACYJNEGO.
       * @param affiliateData Dane do zapiania w ciasteczku
       * @returns 
   */     
   const addAffiliateStatisticRecord = async(affiliateData: IAffiliateDataModel) => {
      const addAffiliateStatisticRecordParams = {
         partnerId: affiliateData.partnerId,
         clientId: affiliateData.clientId,
         affiliateData: JSON.stringify(affiliateData.urlParams),
         source: LoanInitService.AFFILIATE_STATISTIC_FORM_PAGE_VALUE,
      }

      await loanInitService.addAffiliateStatisticRecord(addAffiliateStatisticRecordParams)
   }


   /**
    * Funkcja zwracająca czas wygaśnięcia ciasteczka afiliacyjnego. 
    * W przypadku gdy brak konfiguracji dla danego partnera po stronie Mongo, zwracamy domyślną wartość z konfiguracji (24h)
    * @param partnerId 
    * @returns { Number }
    */
   const getAffiliateCookieExpiresTimeInHours = async (partnerId: affiliatePartnersNames): Promise<number> => {
      const lenConfig = await settingsService.getLenConfig()
      let affiliateCookieExpiresTimeInHoursObject = lenConfig.data.globalConfig.affiliateCookieExpiresTimeInHours
      let affiliateCookieExpiresTimeInHours = Environment.defaultAffiliateCookieExpiresTimeInHours // Domyślny czas żywotności ciasteczka

      if(affiliateCookieExpiresTimeInHoursObject !== undefined && affiliateCookieExpiresTimeInHoursObject[partnerId] !== undefined){
         affiliateCookieExpiresTimeInHours = affiliateCookieExpiresTimeInHoursObject[partnerId]
      }
      else { // Jeśli wartość nie zostanie znaleziona w bazie danych przyjmujemy domyślną
         console.warn("Brak informacji w bazie mongo o czasie żywotności ciasteczek ('affiliateCookieExpiresTimeInHours'), przyjęto domyślną wartość 24h");
      }

      return affiliateCookieExpiresTimeInHours
   } 


   /**
    * Funkcja pomocnicza odpowiedzialna za wykonywanie niezbędnych operacji dla każdego partnera afiliacyjnego.
    * @param affiliateData Dane do zapiania w ciasteczku
    */
   const affiliateLinkEntryHandler = async(affiliateData: IAffiliateDataModel) => {
      await addAffiliateStatisticRecord(affiliateData)
      await setAffiliateCookie(affiliateData)
   }

   useEffect(() => {
      (async() => {
         if(isEmpty(affiliateQueryParamsObjectFromLink)) { //Sytuacja gdy nie ma żadnych parametrów w linku
            console.warn("Podany link afiliacyjny nie posiada żadnych parametrów!")
            return
         }
         else {
            const predefinedAffiliateData = setAffiliateAlternativeOffert()


      // ==================== KONFIGURACJA OBSŁUGI PARTNERÓW AFILIACYJNYCH ==========================
            const AFFILIATE_PARTNERS_CONFIG: IAffiliatePartnersConfigModel = {
               [affiliatePartnersNames.Adtraction]: {
                  getClientId: (params: Record<string, string>) => params['at_gd'], // Nazwa parametru charakterystyczna dla Adtraction. Dokumentacja: https://adtraction.com/server2server.htm?tp=1333495416
                  additionalFunctionToExecute: null,
               },
               [affiliatePartnersNames.Paytree]: {
                  // Jeśli podamy parametr "paytree_client_id" w linku - przepiszemy jego wartość jako clientId, jeśli parametr nie zostanie podany clientId będzie null
                  getClientId: (params: Record<string, string>) => params['paytree_client_id'] !== undefined ? params['paytree_client_id'] : null,
                  additionalFunctionToExecute: () => cookie.remove(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE),  // Ciasteczka dla Paytree mają najwyższy priorytet. Usuwamy więc wszystkie poprzednie ciasteczka (mechanizm biznesowy)
               },
               [affiliatePartnersNames.PaytreeSocialMedia]: {
                  // Jeśli podamy parametr "paytree_client_id" w linku - przepiszemy jego wartość jako clientId, jeśli parametr nie zostanie podany clientId będzie null
                  getClientId: (params: Record<string, string>) => params['paytree_client_id'] !== undefined ? params['paytree_client_id'] : null,
                  additionalFunctionToExecute: () => cookie.remove(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE),  // Ciasteczka dla Paytree mają najwyższy priorytet. Usuwamy więc wszystkie poprzednie ciasteczka (mechanizm biznesowy)
               },
               [affiliatePartnersNames.SM]: {
                  // Jeśli podamy parametr "paytree_client_id" w linku - przepiszemy jego wartość jako clientId, jeśli parametr nie zostanie podany clientId będzie null
                  getClientId: (params: Record<string, string>) => params['sm_client_id'] !== undefined ? params['sm_client_id'] : null,
                  additionalFunctionToExecute: () => {
                     
                     const cookies = new Cookies()
                     const affiliateData: IAffiliateDataModel = cookies.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)
                     
                     if(affiliateData !== undefined && affiliateData.partnerId !== affiliatePartnersNames.Paytree){
                        cookie.remove(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)  // Ciasteczka dla SM mają wysoki priorytet, ale nie najwyższy. Jeśli istnieje ciasteczko Paytree - nie usuwamy go, inne usuwamy (mechanizm biznesowy)
                     }                  
                  }
               },
               [affiliatePartnersNames.CF]: {
                  getClientId:  () => null,
                  additionalFunctionToExecute: null,
               },
               [affiliatePartnersNames.YouMoney]: {
                  getClientId: (params: Record<string, string>) => params['click_id'],
                  additionalFunctionToExecute: null,
               },
               [affiliatePartnersNames.Loando]: {
                  getClientId: (params: Record<string, string>) => params['click_id'],
                  additionalFunctionToExecute: null,
               },
               [affiliatePartnersNames.YouAff]: {
                  getClientId: (params: Record<string, string>) => params['click_id'],
                  additionalFunctionToExecute: null,
               },
               [affiliatePartnersNames.Finperial]: {
                  getClientId: (params: Record<string, string>) => params['click_id'],
                  additionalFunctionToExecute: null,
               },
               [affiliatePartnersNames.Autopay]: {
                  getClientId: (params: Record<string, string>) => params['click_id'],
                  additionalFunctionToExecute: null,
               },
               [affiliatePartnersNames.eHelikon]: {
                  getClientId: (params: Record<string, string>) => params['click_id'],
                  additionalFunctionToExecute: null,
               },
            }
      // ============================================================================================

            for (const [partnerKey, partnerQueryParams] of Object.entries(affiliatePartnersQueryParams)) {
               const partnerConfig = AFFILIATE_PARTNERS_CONFIG[partnerKey as keyof typeof AFFILIATE_PARTNERS_CONFIG]

               if (!partnerConfig) {
                  continue; // Pomijamy partnerów bez konfiguracji
               }
               
               if (hasLinkParamsContainsPartnerParams(partnerQueryParams)) {
                  enablePredefinedPeriodsLogicForAffiliatePartner(dispatch, partnerKey as affiliatePartnersNames) // [ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI

                  const clientId = partnerConfig.getClientId(affiliateQueryParamsObjectFromLink)

                  const affiliateData: IAffiliateDataModel = {
                     ...predefinedAffiliateData,
                     partnerId: partnerKey as affiliatePartnersNames,
                     clientId,
                     urlParams: affiliateQueryParamsObjectFromLink,
                  }

                  partnerConfig.additionalFunctionToExecute?.() // Wykonaj dodatkową funkcję, jeśli istnieje

                  await affiliateLinkEntryHandler(affiliateData)

                  break;
               }
            }
         }

         // Sytuacja w której klient "przyszedł" z kalkulatora pożyczki na stronie informacyjnej, co oznacza że w linku 
         // podane są również parametry pożyczki (liczba rat (instalments) oraz kwota pożyczki (requestedAmount))
         if(affiliateQueryParamsObjectFromLink?.requestedAmount !== undefined && affiliateQueryParamsObjectFromLink?.instalments){
            
            const basicFormSearchParamsFromAffiliateLink = new URLSearchParams({
               requestedAmount: affiliateQueryParamsObjectFromLink.requestedAmount, 
               instalments: affiliateQueryParamsObjectFromLink.instalments
            })
            
            // Robimy redirect na pierwszą stronę formularza, razem z przesłanymi w linku parametrami
            // tam parametry zostaną poprawnie obsłużone
            apphistory.push(`${redirectToPageLink}?${basicFormSearchParamsFromAffiliateLink.toString()}`)
            return 
         }
         
         apphistory.push(redirectToPageLink)

      })()      
   }, [])


   return {

   }
}

export default useAffiliatePageLogic
